<template>
  <div class="settings p-24-32">
    <div class="settings-box">
      <div class="loader" v-if="loader"><img src="@/assets/img/loader.gif" alt=""></div>
      <div class="title-s">{{$t('settings')}}</div>
      <div class="box">
        <span>{{$t('surname')}}</span> <span>{{ profile.lastname }}</span>
      </div>
      <div class="box">
        <span>{{$t('name')}}</span> <span>{{ profile.firstname }}</span>
      </div>
      <div class="box">
        <span>{{$t('middle_name')}}</span> <span>{{ profile.middlename }}</span>
      </div>
      <div class="box">
        <span>Email</span> <span>{{ profile.email }} <button class="edit" data-toggle="modal"
                                                             data-target="#change-email"><img
        src="@/assets/img/icon/edit.svg" alt=""></button></span>
      </div>
      <div class="box">
        <span>{{$t('city')}}</span>
        <select name="" id="" v-model="selectedCity" @change="editUser">
          <option v-for="(city,index) in cities" v-bind:value="city.id" :key="index">{{ city.name }}</option>
        </select>
      </div>
      <div class="box">
        <span>{{$t('date_birth')}}</span> <span>{{ moment(profile.bdate).format('DD.MM.YYYY') }}</span>
      </div>
      <div class="box">
        <span>{{$t('gender')}}</span>
        <div class="form-flex">
          <input type="radio" id="male" name="male" value="0" v-model="gender" @change="editUser" checked="checked">
          <label for="male">{{$t('male')}}</label>
          <input type="radio" id="female" name="female" value="1" @change="editUser" v-model="gender">
          <label for="female">{{$t('female')}}</label>
        </div>
      </div>
<!--       <div class="box">
        <span>{{$t('address_residence')}}</span> <span>{{$t('pushkin')}}</span>
      </div> -->
      <!-- <div class="box">
        <span>{{$t('referral_code')}}</span> <span>{{ profile.ref_code }} <button class="questions" @click="open"><img
        src="@/assets/img/icon/questions.svg" alt=""></button></span>
        <div v-if="showPopover" v-on-click-outside="close" class="ques-text" v-html="$t('text_16')">
        </div>
      </div> -->
    </div>
    <div class="change-password">
      <div class="loader" v-if="loader_pass"><img src="@/assets/img/loader.gif" alt=""></div>
      <div class="title-f">{{$t('change_password')}}</div>
      <form @submit.prevent="changePassword" class="form">
        <div class="password">
          <input :type="passwordFieldType_old" :placeholder="$t('current_password')" v-model="old_password" @input="errorsDel">
          <span @click="switchVisibility(1)" class="eye"
                :class="{active : this.passwordFieldType_old ==='text'}"></span>
        </div>
        <div class="password">
          <input :type="passwordFieldType_new" :placeholder="$t('new_password')" v-model="new_password" @input="errorsDel">
          <span @click="switchVisibility(2)" class="eye"
                :class="{active : this.passwordFieldType_new ==='text'}"></span>
        </div>
        <div class="password">
          <input :type="passwordFieldType_confirm" :placeholder="$t('re_new_password')" v-model="confirm_password"
                 @input="errorsDel"> <span @click="switchVisibility(3)" class="eye"
                                           :class="{active : this.passwordFieldType_confirm ==='text'}"></span></span>
        </div>
        <button
          :class="(this.old_password!='' && this.new_password!='' && this.confirm_password!='') ? 'button-yellow':'button-yellow disabled'">
         {{$t('save')}}
        </button>
        <div class="errors">{{ errors }}</div>
      </form>
    </div>
    <div class="modal-email">
      <div id="change-email" class="modal fade">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img
                src="@/assets/img/icon/close.svg" alt=""></button>
              <div v-if="step_email===1">
                <div class="title-m">{{$t('change_email')}}</div>
                <form @submit.prevent="editUser(); emailStep();">
                  <input type="email" v-model="email" required placeholder="$t('new_email'">
                  <button class="button-yellow">{{$t('save')}}</button>
                </form>
              </div>
              <div v-if="step_email===2">
                <div class="title-m">{{$t('emai_changed')}}</div>
                <button class="button-yellow" data-dismiss="modal" aria-hidden="true">OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-email">
      <div id="change-password" class="modal fade">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img
                src="@/assets/img/icon/close.svg" alt=""></button>
              <div class="title-m">{{$t('password_changed')}}</div>
              <button class="button-yellow" data-dismiss="modal" aria-hidden="true">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'settings',
  data() {
    return {
      showPopover: false,
      loader: false,
      loader_pass: false,
      success: '',
      old_password: '',
      new_password: '',
      confirm_password: '',
      profile: '',
      errors: '',
      passwordFieldType_old: 'password',
      passwordFieldType_new: 'password',
      passwordFieldType_confirm: 'password',
      cities: '',
      selectedCity: null,
      step_email: 1,
      gender: null,
      email: ''
    }
  },
  watch: {
    // selectedCity(newValue, oldValue) {
    //   if (newValue != oldValue) {
    //     this.editUser();
    //   }
    // },
    // gender(newValue, oldValue) {
    //   if (newValue != oldValue) {
    //     this.editUser();
    //   }
    // }
  },
  mounted() {
    var app = this;
    $('#change-password').on('hidden.bs.modal', function () {
      window.location.replace('/cabinet/settings')
    });
    $('#change-email').on('hidden.bs.modal', function () {
      app.step_email = 1;
      app.email = app.profile.email;
    });
  },
  created() {
    this.getСitiesList();
    this.getUser();
  },
  methods: {
    open() {
      this.showPopover = true
    },
    close() {
      this.showPopover = false
    },
    getUser() {
      this.loader = false
       this.profile = JSON.parse(localStorage.getItem("user"));
            this.selectedCity = this.profile.city.id
            this.gender = this.profile.gender
            this.email = this.profile.email
    },
    changePassword() {
      this.loader_pass = true
      let obj = {}
      obj['old_password'] = this.old_password
      obj['new_password'] = this.new_password
      obj['confirm_password'] = this.confirm_password
      this.$axios.post('/user/change-password', obj)
        .then((response) => {
          let $response = response.data
          if ($response.code === 0) {
            this.errors = $response.message
          } else {
            this.$auth.saveToken('Basic ' + btoa(this.profile.iin + ':' + this.new_password))
            $('#change-password').modal('show');
          }
          this.loader_pass = false
        })
        .catch((e) => console.log(e))
    },
    errorsDel() {
      this.errors = '';
    },
    switchVisibility(index) {
      if (index == 1) {
        this.passwordFieldType_old = this.passwordFieldType_old === 'password' ? 'text' : 'password'
      }
      if (index == 2) {
        this.passwordFieldType_new = this.passwordFieldType_new === 'password' ? 'text' : 'password'
      }
      if (index == 3) {
        this.passwordFieldType_confirm = this.passwordFieldType_confirm === 'password' ? 'text' : 'password'
      }
    },
    getСitiesList() {
      this.$axios.get('/location/cities-list')
        .then((response) => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
          } else {
            this.cities = $response.data
          }
        })
        .catch((e) => console.log(e))
    },
    editUser() {
      this.loader = true
      localStorage.removeItem('user');
      let obj = {}
      obj['firstname'] = this.profile.firstname
      obj['lastname'] = this.profile.lastname
      obj['middlename'] = this.profile.middlename
      obj['bdate'] = this.profile.bdate
      obj['city_id'] = this.selectedCity
      obj['email'] = this.email
      obj['gender'] = this.gender
      obj['password'] = this.password
      // obj['refcode'] = this.profile.ref_code
      obj['phone'] = this.profile.phone
      this.$axios.post('/user/save', obj)
        .then((response) => {
          let $response = response.data
          if ($response.code === 0) {
            this.errors = $response.message
            this.loader = false
          } else {
            this.profile = $response.data
            localStorage.setItem("user", JSON.stringify(this.profile));
            this.loader = false
          }
        })
        .catch((e) => console.log(e))
    },
    emailStep() {
      this.step_email = 2;
    }
  }
}
</script>
<style scoped>
.errors {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/cabinet/settings.vue